import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function FundingHero({ onExplore, onStartFunding }) {
  const navigate = useNavigate();

  return (
    <section className="funding-hero" aria-labelledby="funding-hero-title">
      <div className="funding-hero-glow funding-hero-glow--gold" aria-hidden />
      <div className="funding-hero-glow funding-hero-glow--blue" aria-hidden />
      <div className="funding-hero-inner">
        <button type="button" className="funding-hero-back" onClick={() => navigate('/')}>
          ← Back to home
        </button>
        <p className="funding-hero-eyebrow">Creator&apos;s Arch · Funding Zone</p>
        <h1 id="funding-hero-title" className="funding-hero-title">
          Fuel Creative Projects
        </h1>
        <p className="funding-hero-sub">
          Discover and support student ideas, films, podcasts, startups, and creative ventures.
        </p>
        <div className="funding-hero-cta-row">
          <button type="button" className="funding-cta funding-cta--primary" onClick={onExplore}>
            Explore Projects
          </button>
          <button type="button" className="funding-cta funding-cta--ghost" onClick={onStartFunding}>
            Start Funding
          </button>
        </div>
      </div>
    </section>
  );
}
